var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgViber = function SvgViber(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_9_1",
    "data-name": "Component 9 \\u2013 1",
    width: 26.535,
    height: 27.983,
    viewBox: "0 0 26.535 27.983",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M1619.542,30.783c-.694-.639-3.5-2.678-9.765-2.705,0,0-7.383-.442-10.979,2.858-2,2-2.705,4.935-2.782,8.568s-.169,10.443,6.394,12.29h.006l-.006,2.82s-.044,1.142.71,1.372c.907.284,1.443-.585,2.311-1.519.476-.513,1.131-1.268,1.629-1.842a25.409,25.409,0,0,0,8.333-.612c.907-.3,6.039-.951,6.869-7.76C1623.127,37.226,1621.848,32.789,1619.542,30.783Zm.76,12.957c-.7,5.683-4.864,6.044-5.629,6.29a23.5,23.5,0,0,1-7.17.612s-2.842,3.426-3.727,4.317c-.29.29-.606.262-.6-.312,0-.377.022-4.683.022-4.683h0c-5.563-1.541-5.235-7.339-5.175-10.372s.634-5.519,2.328-7.191c3.044-2.76,9.312-2.35,9.312-2.35,5.3.022,7.831,1.618,8.421,2.153C1620.034,33.876,1621.029,37.877,1620.3,43.74Z",
    transform: "translate(-1596 -28.059)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M1626.2,46.836a.353.353,0,0,0-.038.7,1.69,1.69,0,0,1,1.781,1.852.353.353,0,1,0,.7-.033A2.376,2.376,0,0,0,1626.2,46.836Z",
    transform: "translate(-1611.944 -38.094)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M1629.846,47.817a4.786,4.786,0,0,0-4.8-5.055.353.353,0,0,0-.049.7,4.083,4.083,0,0,1,4.142,4.334A.353.353,0,0,0,1629.846,47.817Z",
    transform: "translate(-1611.326 -35.916)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M1623.692,38.819a.352.352,0,0,0,0,.7c3.6.027,6.568,2.454,6.6,6.907a.352.352,0,1,0,.7-.006C1630.96,41.628,1627.72,38.846,1623.692,38.819Z",
    transform: "translate(-1610.614 -33.81)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M1622.274,51.423a14.139,14.139,0,0,0-2.5-1.8,1.141,1.141,0,0,0-1.453.2l-.525.656a.962.962,0,0,1-.765.29,6.844,6.844,0,0,1-4.607-4.607.963.963,0,0,1,.29-.765l.656-.525a1.141,1.141,0,0,0,.2-1.453c-.191-.333-.558-.929-.831-1.3-.29-.4-.967-1.208-.967-1.208a1,1,0,0,0-1.306-.213h-.011c-1.044.59-2.186,1.694-1.819,2.831a16.306,16.306,0,0,0,1.421,3.044,17.75,17.75,0,0,0,1.683,2.547,14.3,14.3,0,0,0,2.317,2.317,20.991,20.991,0,0,0,5.585,3.087l.011.017c1.136.366,2.241-.782,2.831-1.82v-.011A.977.977,0,0,0,1622.274,51.423Z",
    transform: "translate(-1602.715 -34.735)",
    fill: "#fff"
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgViber, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/viber.b8881f2e.svg";
export { ForwardRef as ReactComponent };